import React, { useState } from 'react';
import AppBar from "@mui/material/AppBar";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Mtable_Implementadores from './Mtable_Implementadores';
import ControlesAdherencia from './ControlesAdherencia';

const MainImplementadores = () => {
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div>
            <AppBar position="static" style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}>
                <Tabs value={value} onChange={handleChange}>
                    <Tab label="Controles" style={{ color: "#ffffff" }} />
                    <Tab label="Adherencia" style={{ color: "#ffffff", padding: "3px 7px 3px" }} />
                </Tabs>
            </AppBar>
            {value === 0 && <Mtable_Implementadores />}
            {value === 1 && <ControlesAdherencia  />}
        </div>
    );
};

export default MainImplementadores;

